<template>
  <div class="hmseries-and-footer">
    <hmseries></hmseries>
    <scfooter></scfooter>
  </div>
</template>

<script>

 export default {
   name: 'hmcosmetics',
   components: {
     hmseries: () => import('../components/HMseries.vue'),
     scfooter: () => import('../components/scFooter.vue')
   },
 }
</script>

<style lang="scss" scoped>
 $page-width: 960px;
 a {
   text-decoration: none;
 }

 .hmseries-and-footer {
   margin-top: 80px;
 }

 @media (max-width: 600px) {
   .hmseries-and-footer {
     margin-top: 20px;
   }
 }
</style>
